/* eslint-disable @nx/enforce-module-boundaries */
import { loan_application } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { getFormattedAmountUI } from '@axo/shared/util/formatters';
import { Card } from '@axo/ui-core/components/Card';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Heading, Text } from '@axo/ui-core/components/typography';
import styles from './ESkat.module.scss';

type DebtInfoProps = {
  debt: loan_application.Debt;
};
export const DebtInfo = (props: DebtInfoProps) => {
  const { debt } = props;

  const { t } = useTranslation();

  const { Type, Creditor, OutstandingAmount, MonthlyDebtPayment } = debt;

  const text = Creditor ? Creditor : t('Debt.OutstandingAmount.title');

  return (
    <Card spacing="small">
      <div className={styles.debtHeading}>
        <Heading size="xs">{t(`Debt.Type.${Type}`)}</Heading>
      </div>

      <Stack gap="3xs" className={styles.fullWidth}>
        <div className={styles.spaceBetween}>
          <Text>
            <b>{text}</b>
          </Text>
          <Text>
            <b>
              {getFormattedAmountUI(OutstandingAmount)} {t('suffix.currency')}
            </b>
          </Text>
        </div>

        {MonthlyDebtPayment && MonthlyDebtPayment > 0 && (
          <div className={styles.spaceBetween}>
            <Text>{t('Debt.MonthlyDebtPayment.label')}</Text>
            <Text>
              {getFormattedAmountUI(MonthlyDebtPayment)} {t('suffix.currency')}
            </Text>
          </div>
        )}
      </Stack>
    </Card>
  );
};
